import { render, staticRenderFns } from "./EmailListManagement.vue?vue&type=template&id=e7481136"
import script from "./EmailListManagement.vue?vue&type=script&lang=js"
export * from "./EmailListManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports